/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */
import { Image } from 'components/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Lorsqu’elle quitte l’étable où elle a passé l’hiver, Erika monte, âgée de six mois, pour la première fois à l’alpage. Où elle peut s’ébattre librement. Selon la législation suisse, tous les bovins doivent être sortis chaque année en plein air durant 90 jours au minimum. Tout comme Erika, 270’000 vaches montent des vallées sur les pâturages de montagne en été. Un bel effort: en moyenne Erika et ses congénères marcheurs grimpent en zigzagant 16,3 kilomètres de pente souvent fort raides.`}</p>
    <p>{`À l’alpage, Erika se nourrit de différentes graminées et herbacées tout en se reposant jusqu’à douze heures par jour. Elle participe ainsi à la sauvegarde des paysages ruraux traditionnels, empêchant les pâturages de redevenir forêts. La Confédération soutient le séjour estival d’Erika: par vache et par été (100 jours de résidence), le paysan touche 370 francs.`}</p>
    <Image file={['subventionen-fr-01.png', 'subventionen-fr-02.png']} title='Trois exemples de subvention' source='Source: Office fédéral de l’agriculture' mdxType="Image" />
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  